export const PS_MASTER_HEADER_LOADER = {
  desktop: `
<div class="cui-grid">
  <div class="cui-container display-none display-lg-block -spacing--top-24">
    <div class="cui-row -spacing--bottom-16">
      <div class="cui-col-lg-2">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 40px;"></div>
        </div>
      </div>
      <div class="cui-col-lg-4 col-offset-lg-6">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 18px;"></div>
        </div>
      </div>

    </div>
    <div class="cui-row -spacing--bottom-24">
      <div class="cui-col-lg-4">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 18px;"></div>
        </div>
      </div>
      <div class="cui-col-lg-3 col-offset-lg-3">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 40px;"></div>
        </div>
      </div>
      <div class="cui-col-lg-1">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 40px;"></div>
        </div>
      </div>
      <div class="cui-col-lg-1">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 40px;"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="cui-container display-none display-md-block display-lg-none -spacing--top-24">
    <div class="cui-row -spacing--bottom-16">
      <div class="cui-col-md">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 40px;"></div>
        </div>
      </div>
      <div class="cui-col-md-4">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 40px;"></div>
        </div>
      </div>
      <div class="cui-col-md">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 40px;"></div>
        </div>
      </div>
    </div>
    <div class="cui-row -spacing--bottom-24">
      <div class="cui-col-md-4">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 20px;"></div>
        </div>
      </div>
      <div class="cui-col-md-2 col-offset-md-2">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 20px;"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="cui-container display-block display-md-none -spacing--top-16">
    <div class="cui-row -spacing--bottom-16">
      <div class="cui-col-sm-1">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 32px;"></div>
        </div>
      </div>
      <div class="cui-col-sm-1 col-offset-sm-2">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 32px;"></div>
        </div>
      </div>
    </div>
    <div class="cui-row -spacing--bottom-16">
      <div class="cui-col-md-12">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 40px;"></div>
        </div>
      </div>
    </div>
  </div>
</div>`
};
